































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */
import TicketPortalHeader from './components/ticket-portal-header.vue'
import TicketPortalFooter from './components/ticket-portal-footer.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */

/* API */
import TicketPortalAPI from '@/api/modules/ticket-portal.api'
import { ITicketPortalOutputProfile } from '@/api/types/response.types'
import { ITicketPortalInputUpdateProfile } from '@/api/types/request.types'

export default Vue.extend({
  name: 'TicketPortalProfile',

  metaInfo(): any {
    return {
      title: this.data.ticketPortalName,
    }
  },

  components: { TicketPortalHeader, TicketPortalFooter },

  data() {
    return {
      RouteAssistant,
      isLoading: true,
      isSubmitting: false,
      data: {} as ITicketPortalOutputProfile,
    }
  },

  computed: {
    mailboxID(): number {
      return Number(this.$route.params.mailboxId)
    },
  },

  async created() {
    this.isLoading = true
    await this.getProfile()
    this.isLoading = false
  },

  methods: {
    async getProfile() {
      try {
        this.data = await TicketPortalAPI.get_Profile(this.mailboxID)
      } catch (error) {
        this.$error.emit(error)
      }
    },
    async updateProfile() {
      try {
        this.isSubmitting = true
        const data = {
          name: this.data.name,
          timezone: this.data.timezone,
        } as ITicketPortalInputUpdateProfile
        const response = await TicketPortalAPI.put_Profile(this.mailboxID, data)
        this.$messaging.showSuccess(response.message)
      } catch (error) {
        this.$error.emit(error)
      } finally {
        await this.getProfile()
        this.isSubmitting = false
      }
    },
  },
})
